import $ from 'jquery'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { selectUserData } from '../../reducers/userDataReducer'

import SelectEventType from './components/SelectEventType/SelectEventType'
import AppointmentEvent from './components/AppointmentEvent/AppointmentEvent'
import ReminderEvent from './components/ReminderEvent/ReminderEvent'
import ClassEvent from './components/ClassEvent/ClassEvent'
import BuildingEvent from './components/BuildingEvent/BuildingEvent'

export class CreateEvent extends React.Component {
  constructor(props) {
    super(props)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
    this.setActiveFilter = this.setActiveFilter.bind(this)
    this.state = {
      activeFilter: '',
      trainingTypes: [],
      trainers: [],
      clients: [],
      locations: [],
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape)
    window.addEventListener('click', this.clickHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) this.props.close()
  }

  clickHandler(e) {
    if ($(e.target).attr('class') === 'ctp-create-event-modal') this.props.close()
  }

  setActiveFilter(filter) {
    this.setState((prev) => ({ ...prev, activeFilter: filter }))
  }

  renderEventType() {
    switch (this.state.activeFilter) {
      case 'reminder':
        return (
          <ReminderEvent goBack={() => this.setActiveFilter('')} handleClose={this.props.close} />
        )
      case 'class':
        return <ClassEvent goBack={() => this.setActiveFilter('')} handleClose={this.props.close} />
      case 'appointment':
        return (
          <AppointmentEvent
            goBack={() => this.setActiveFilter('')}
            handleClose={this.props.close}
          />
        )
      case 'event':
        return (
          <BuildingEvent goBack={() => this.setActiveFilter('')} handleClose={this.props.close} />
        )
      case '':
        return (
          <SelectEventType handleClose={this.props.close} role={this.props.userData.user.role} />
        )
    }
  }

  render() {
    return this.renderEventType()
  }
}

CreateEvent.propTypes = {
  userData: PropTypes.object,
  close: PropTypes.func,
  eventForClient: PropTypes.bool,
}

export default connect((state) => ({ userData: selectUserData(state) }), null, null, {
  withRef: true,
})(CreateEvent)
